import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { logout } from '../../actions/auth';



const SidebarAdmin = ({ logout, auth: {user} }) => {


	const [pathPage, setPathPage] = useState(window.location.pathname);
	const [classToggle, setClassToggle] = useState(false)



	useEffect(() => {
		// Funzione per aggiornare pathPage quando cambia l'URL
		const handleLocationChange = () => {
			setPathPage(window.location.pathname);
		};

		// Aggiungi l'evento popstate per rilevare la navigazione con il pulsante indietro/avanti
		window.addEventListener('popstate', handleLocationChange);

		// Aggiungi l'evento hashchange per Safari o altre situazioni particolari
		window.addEventListener('hashchange', handleLocationChange);

		// Verifica modifiche manuali alla history API
		const originalPushState = window.history.pushState;
		const originalReplaceState = window.history.replaceState;

		window.history.pushState = function (...args) {
			originalPushState.apply(this, args);
			handleLocationChange();
		};

		window.history.replaceState = function (...args) {
			originalReplaceState.apply(this, args);
			handleLocationChange();
		};

		// Cleanup: rimuovi gli eventi quando il componente viene smontato
		return () => {
			window.removeEventListener('popstate', handleLocationChange);
			window.removeEventListener('hashchange', handleLocationChange);
			window.history.pushState = originalPushState;
			window.history.replaceState = originalReplaceState;
		};
	}, []);


	const generaMenu = () => {
		return (
			<nav role="navigation" className="nav-menu-4 w-nav-menu">
				<div className="div-block-7">
					<div className="div-block-8">
						<ul role="list" class="list-gestione">
							<li>
								<a href="/gestione-portale" onClick={() => setPathPage("/gestione-portale")} className={`nav-link w-nav-link${pathPage === '/gestione-portale' ? ' w--current' : ''}`}>Eventi</a>
							<div class="child">
								<a href="/archivio-eventi" onClick={() => setPathPage("/archivio-eventi")} className={`nav-link child w-nav-link${pathPage === '/archivio-eventi' ? ' w--current' : ''}`}>Archivio</a>
								<a href="/aggiungi-evento" onClick={() => setPathPage("/aggiungi-evento")} className={`nav-link child w-nav-link${pathPage === '/aggiungi-evento' ? ' w--current' : ''}`}>Aggiungi evento agenda</a>
								</div>
							</li>	
							<li>
								<a href="/gestione-audio" onClick={() => setPathPage("/gestione-audio")} className={`nav-link w-nav-link${pathPage === '/gestione-audio' ? ' w--current' : ''}`}>Materiale sempre disponibile</a>
							<div class="child">
								<a href="/aggiungi-audio" onClick={() => setPathPage("/aggiungi-audio")} className={`nav-link child w-nav-link${pathPage === '/aggiungi-audio' ? ' w--current' : ''}`}>Aggiungi materiale</a>
								</div>
							</li>		
							<li>
								<a href="/lista-utenti" onClick={() => setPathPage("/lista-utenti")} className={`nav-link w-nav-link${pathPage === '/lista-utenti' ? ' w--current' : ''}`}>Lista utenti</a>
							</li>					
						</ul>
					</div>
					<div className="div-block-6">
						<a className="nav-link user-link w-nav-link" href="" onClick={() => logout()}>Logout</a>
					</div>
				</div>
			</nav>
		)
	}

	return (
		

		  <div className="area-user wf-section">
			<div className="wrap-user">
				<div className="navigation-area">
					<div data-animation="over-left" data-collapse="small" data-duration="400" data-easing="ease" data-easing2="ease" role="banner" className="navbar w-nav">
						<div className="container-2 w-container">
							<div className='topbar-logo-admin'>
							<a href="/" aria-current="page" className="brand w-nav-brand w--current logo-fondazione"><img src="/assets/media/fondazione_danesino_logo.svg" loading="lazy" alt="" className="logo-header" /></a>
							<a href="/" aria-current="page" className="brand w-nav-brand w--current"><img src="/assets/media/noi_con_voi-fondazione_danesino-logo--oriz.png" loading="lazy" alt="" className="logo-header" /></a>
							</div>
							<div className="div-block-4">
								<div className="div-block-4">
									{classToggle ? '' : generaMenu()}
								</div>
							</div>
							<div className="menu-button w-nav-button" onClick={() => setClassToggle(!classToggle)}>
								<div className="icon w-icon-nav-menu"></div>
							</div>
							<div className={`w-nav-overlay${classToggle ? ' hamburger-sel' : ''}`} data-wf-ignore="" id="w-nav-overlay-0">
								{classToggle ? generaMenu() : ''}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	)
}

SidebarAdmin.protoTypes = {
	logout: PropTypes.func.isRequired,
	auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
	auth: state.auth
});

export default connect(mapStateToProps, { logout })(SidebarAdmin);

